import * as c from '@Alternatives/Forms/Domain/commands-core';
import { AttributeFormDefinitionDTO } from '@Alternatives/Model';
import VueCqrs from '@cqrs/vue-component-cqrs';
import Component from 'vue-class-component';

@Component
export default class FormsCommands extends VueCqrs 
{
	invokeUpdateFormDefinitionCommandV1(workspaceId: number, projectId: number, alternativesListId: number, formId: number, name: string,
		description: string | null, blurb: string | null, blurbVisible: boolean, nameReadonly: boolean,
		descriptionReadonly: boolean, statusReadonly: boolean, includeDescription: boolean, includeStatus: boolean, attributesDefinitions: AttributeFormDefinitionDTO[])
	{
		const cmd = new c.UpdateFormDefinitionCommandV1(workspaceId, projectId, alternativesListId, formId, name,
			description, blurb, blurbVisible, nameReadonly, descriptionReadonly, statusReadonly, includeDescription, includeStatus, attributesDefinitions);
		this.$command(cmd);
	}

	invokeCreateFormCommandV1(workspaceId: number, projectId: number, formId: number, name: string, sourceId: number | null)
	{
		const cmd = new c.CreateFormCommandV1(workspaceId, projectId, formId, name, sourceId);
		this.$command(cmd);
	}

	invokeRenameFormCommandV1(workspaceId: number, projectId: number, formId: number, name: string)
	{
		const cmd = new c.RenameFormCommandV1(workspaceId, projectId, formId, name);
		this.$command(cmd, formId.toString());
	}

	invokeDeleteFormCommandV1(workspaceId: number, projectId: number, alternativesListId: number, formId: number)
	{
		const cmd = new c.DeleteFormCommandV1(workspaceId, projectId, alternativesListId, formId);
		this.$command(cmd, formId.toString());
	}
}